@use '~/theme/theme' as *;
@use '~/theme/typography';

.container {
  display: flex;
  flex-direction: column;
  gap: spacing(5);
}

.row {
  display: flex;
  gap: spacing(1);
  align-items: center;
}

.label {
  flex-basis: 120px;
}

.fieldContainer {
  flex-basis: 300px;
}

.flowFormContainer {
  display: flex;
}
